import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import 'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/quickquote/pa/app';

var lobModules = [];

if (!ApplicationFeatures.hasFeature('role.vendor')) {
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
        lobModules.push('edge.quoteandbind.quickquote.pa.app');
    }
}

export default lobModules;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/quickquote/SupportedLobModules.js
// module id = 1225
// module chunks = 0